<template>
  <div class="x-tablelist-view user-list-group" data-automation="userListGroup">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @input="seach"
      @search="seach"
      @add="showAdd"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :emptyText="$t('HT.nodata')"
        :columns="columns"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
<script>
import addUserGroup from './template/addUserGroup';
import addMenuEdit from './template/addMenuEdit';
let userData;
export default {
  components: {
    addUserGroup,
    addMenuEdit
  },
  data() {
    userData = this.$store.state.login.userData;
    return {
      layout: [
        // 搜索项配置
        // {
        //     type: 'input',
        //     key: 'keyword',
        //     placeholder: '请输入账号名称进行搜索'
        // },
        {
          type: 'button',
          text: this.$t('HT.userList.addGroup'),
          // right: true,
          hidden: userData.supervisor ? false : !this.$hasModule(29),
          event: 'add'
        }
      ],
      columns: [
        // 表头数据
        {
          label: this.$t('HT.addUserGroup.name'),
          prop: 'group_name',
          align: 'left',
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepOne.remark'),
          prop: 'remark',
          align: 'left',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return cellValue || '--';
          }
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(29),
          align: 'left',
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [this.$t('HT.router.jurisdiction'), this.$t('HT.delete')],
                colors: ['#0087ff', '#f45c5c'],
                event: ['editMenu', 'del']
              },
              on: {
                editMenu: () => {
                  this.$router.push(`/jurisdiction/${params.id}/?name=${params.group_name}`);
                },
                del: () => {
                  const title = this.$t('HT.userList.delGroup');
                  const content = this.$t('HT.userList.delGroup.content');
                  this.$uxModal.show({
                    title,
                    content,
                    confirm: () => {
                      this.deleteGroup(params);
                    }
                  });
                }
              }
            });
          }
        }
      ],
      filter: {
        // 查询参数
        keyword: '', // 名称
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /**
     * 删除用户组
     * @param {Object} params 请求参数
     */
    deleteGroup(params) {
      this.$api.system.delGroup(params.id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
          this.getList();
        }
      });
    },
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList() {
      this.$uxLoading.show();
      this.$api.system.getGroup().then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            // totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },
    /**
     * 新建分组弹窗
     */
    showAdd() {
      const title = this.$t('HT.userList.addGroup');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addUserGroup);
        },
        confirm: (params) => {
          this.addUserGroupList(params);
        }
      });
    },
    /**
     * 方法
     * @param {Object} params 查询对象
     */
    addUserGroupList(params) {
      this.$api.system.createGroup(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
          this.getList();
        }
      });
    },
    /**
     * 搜索
     */
    seach() {
      this.filter.page = 1;
      this.getList(this.filter);
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>

<style lang="scss" scoped>
.user-list-group {
  padding: 20px;

  .ux-search-option {
    height: auto;
    min-height: auto;
    line-height: normal;
    margin-bottom: 20px;
  }
}
</style>
